<script lang="ts">
  import { onDestroy } from "svelte";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../../../lib/mountFederatedSvelteComponent";

  export let errors: number = 0;

  let container: HTMLDivElement | null = null;
  let instance: any = null;
  let RemoteComponent: any = null;

  function mount() {
    if (!container) return;
    const doMount = (Component: any) => {
      instance = mountFederatedSvelteComponent(instance, Component, {
        target: container!,
        props: { errors },
      });
    };
    if (RemoteComponent) doMount(RemoteComponent);
    else {
      // @ts-ignore - App2 remote
      import("App2/conflictsSummary")
        .then((m) => {
          RemoteComponent = m.default;
          doMount(RemoteComponent);
        })
        .catch((err) => console.warn("App2/conflictsSummary not available:", err));
    }
  }

  $: if (container && !instance) mount();
  $: if (instance) instance.$set({ errors });

  onDestroy(() => {
    instance = destroySvelteComponentInstance(instance);
  });
</script>

<div bind:this={container} data-conflicts-summary-host></div>
